import { httpClient } from "../../../lib/axios";

export const coupons_api = {
  get: async () => {
    return await httpClient
      .get("coupon/?admin=true")
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  add: async payload => {
    return await httpClient
      .post("coupon/", payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  addOfferCoupon: async payload => {
    return await httpClient
      .post("coupon/?offer_coupon=true", payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  edit: async (id, payload) => {
    return await httpClient
      .put(`coupon/?coupon_id=${id}`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  changeStatus: async payload => {
    return await httpClient
      .put("coupon/?status=true", payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  delete: async id => {
    return await httpClient
      .delete(`coupon/?coupon_id=${id}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  bulkDelete: async payload => {
    return await httpClient
      .delete(`review/?delete=true`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },

yearlyCouponGet: async params => {
    return await httpClient
      .get("yearly_coupon/", { params })
      .then(res => res.data)
      .catch(err => err);
  },

  monthlyUserPurchaseGet: async () => {
  return await httpClient
    .get("monthly_user_purchase/")
    .then(res => res.data)
    .catch(err => err);
},
updateMonthlyCutoff: async (id, payload) => {
  return await httpClient
    .put(`monthly_user_purchase/?id=${id}`, payload)
    .then(res => res.data)
    .catch(err => err);
},
referralCouponsGet: async (params = {}) => {
  return await httpClient
    .get("referralCoupons/", { params })
    .then(res => res.data)
    .catch(err => err);
},
settingsGet: async () => {
  return await httpClient
    .get("settings/")
    .then(res => res.data)
    .catch(err => err);
},
settingsUpdate: async payload => {
  return await httpClient
    .put("settings/", payload)
    .then(res => res.data)
    .catch(err => err);
},

};
